import Vue from 'vue'
import VueI18n from 'vue-i18n'
import {
  Message
} from 'element-ui'

import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
import enLocale from 'element-ui/lib/locale/lang/en'
import elementLocale from 'element-ui/lib/locale'

// 引入项目的本地化文件（假设你有对应的翻译 JSON）
import customZh from '@/locales/zh.json'
import customEn from '@/locales/en.json'

Vue.use(VueI18n)

// 语言包合并（Element UI + 自定义）
const messages = {
  'cn': {
    ...zhLocale,
    ...customZh
  },
  'en': {
    ...enLocale,
    ...customEn
  }
}

// 创建 i18n 实例
const i18n = new VueI18n({
  locale: localStorage.getItem('language') || 'cn', // 读取本地存储的语言
  messages
})

// 设置 Element UI 语言
elementLocale.use(messages[i18n.locale])

Vue.prototype.$message = Message

export default i18n
